import type { DashboardFilters, Paginated } from '@oxxean/types';
import type {
  Finding,
  FindingInput,
  InspectionObservation,
  InspectionObservationInput,
  LaborRelationsCase,
  LaborRelationsCaseInput,
} from '../../types/domain';
import type { TableState } from '../../hooks/useTableState';
import { http } from '../http';
import { filtersToParams, tableStateToParams } from './params';

/** Datos que nacen en la plataforma (§19). Nunca se pierden en una resincronización. */

export async function fetchLaborRelations(
  filters: DashboardFilters,
  state: TableState,
): Promise<Paginated<LaborRelationsCase>> {
  const response = await http.get<Paginated<LaborRelationsCase>>('/labor-relations', {
    params: { ...filtersToParams(filters), ...tableStateToParams(state) },
  });
  return response.data;
}

export async function createLaborRelationsCase(
  payload: LaborRelationsCaseInput,
): Promise<LaborRelationsCase> {
  const response = await http.post<LaborRelationsCase>('/labor-relations', payload);
  return response.data;
}

export async function updateLaborRelationsCase(
  id: string,
  payload: LaborRelationsCaseInput,
): Promise<LaborRelationsCase> {
  const response = await http.put<LaborRelationsCase>(`/labor-relations/${id}`, payload);
  return response.data;
}

export async function deleteLaborRelationsCase(id: string): Promise<void> {
  await http.delete(`/labor-relations/${id}`);
}

export async function fetchInspections(
  filters: DashboardFilters,
  state: TableState,
): Promise<Paginated<InspectionObservation>> {
  const response = await http.get<Paginated<InspectionObservation>>('/inspections', {
    params: { ...filtersToParams(filters), ...tableStateToParams(state) },
  });
  return response.data;
}

export async function createInspection(
  payload: InspectionObservationInput,
): Promise<InspectionObservation> {
  const response = await http.post<InspectionObservation>('/inspections', payload);
  return response.data;
}

export async function updateInspection(
  id: string,
  payload: InspectionObservationInput,
): Promise<InspectionObservation> {
  const response = await http.put<InspectionObservation>(`/inspections/${id}`, payload);
  return response.data;
}

export async function deleteInspection(id: string): Promise<void> {
  await http.delete(`/inspections/${id}`);
}

export async function fetchFindings(
  filters: DashboardFilters,
  state: TableState,
): Promise<Paginated<Finding>> {
  const response = await http.get<Paginated<Finding>>('/findings', {
    params: { ...filtersToParams(filters), ...tableStateToParams(state) },
  });
  return response.data;
}

export async function createFinding(payload: FindingInput): Promise<Finding> {
  const response = await http.post<Finding>('/findings', payload);
  return response.data;
}

export async function updateFinding(id: string, payload: FindingInput): Promise<Finding> {
  const response = await http.put<Finding>(`/findings/${id}`, payload);
  return response.data;
}

export async function deleteFinding(id: string): Promise<void> {
  await http.delete(`/findings/${id}`);
}
